import React from "react";

import mainimg from "../../Assets/png/mainimg.png"
import subimg from "../../Assets/png/subimg.png"
import sideimg from "../../Assets/png/sideimg.png"
import mawaloglogo from "../../Assets/png/mawaloglogo.png"


const Register=()=>{
    return(
        <div style={{display:'flex'}}>
            <div style={{height:'100vh',width:'40%',backgroundColor:"#DEEDFF",paddingLeft:'63px',paddingRight:'63px',paddingTop:'24px',display:'flex',flexDirection:'column'}}>
                <div style={{marginBottom:'24px'}}>
                    <span style={{fontFamily:'Aileron',fontWeight:'600',fontSize:'16px',lineHeight:'19.2px',color:'#21272C'}}>Mawalog</span>
                </div>

                <div style={{marginBottom:'24px'}}>
                    <span style={{fontFamily:'Aileron',fontWeight:'700',fontSize:'36px',lineHeight:'43.2px',color:'#21272C'}}>All-in-one-workplace</span>
                </div>

                <div style={{marginBottom:'24px'}}>
                    <span style={{fontFamily:'Aileron',fontWeight:'400',fontSize:'14px',lineHeight:'16.8px',color:'#21272C'}}>Configure the all user roles and accessibility from here
                    to all applications</span>
                </div>

                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <img src={mainimg} style={{width:'474px',height:'316px',margin:'0'}} />

                </div>   

            </div>

            <div style={{width:'60%',height:'100vh'}}>

            </div>


        </div>
    );
};

export default Register;